import React from 'react';
import { useHistory } from 'react-router-dom';
import { toTitleCase } from 'utils/strings';
import { Button } from '../../components';
import useConnectIntegration from '../../hooks/useConnectIntegration';
import { Layout, StyledAuthHeader } from './styles';

export const Success: React.FC = () => {
  const integration = useConnectIntegration();
  const history = useHistory();

  return (
    <Layout>
      <StyledAuthHeader
        logo={integration.logo()}
        data-cy="auth-header-login"
        title={`Your ${toTitleCase(integration.name)} Account has been successfully authenticated.`}
        subtitle="Our support team will begin setting up your account and reach out to you."
      />
      <Button label="Continue" onClick={() => history.push(`/connect/${integration.name}/connections`)} />
    </Layout>
  );
};
